export default {

    getOauthUser() {
      if(localStorage.getItem('user'))
        return JSON.parse(localStorage.getItem('user'));
      return false;
    },

    setOauthUser(user) {
        localStorage.setItem('user', JSON.stringify(user));
    },

    removeOauthUser() {
        localStorage.removeItem('user');
    },

    clearUserResource() {
        this.removeOauthUser();

        this.removeToken();

        this.authenticated = false;
    },

    // fetch from authentication server through api.
    fetchUser(context, url, callback) {
        axios.get(url, {
          headers: this.authHeader()
        })
            .then(
            (data) => {
                const user = data.data;

                this.setOauthUser(user);

                return this.processSuccess({user, status: true}, callback);
            },
            (error) => {
                this.clearUserResource();
                return this.processError({
                    error: error,
                    status: false
                }, callback);
            }
        )
    },

    // global success response handler.
    processSuccess(response, callback) {
        // process common things here,
        // if needed before returning.

        if (typeof callback === 'function') {
            return callback(response);
        }
    },

    // global error response handler.
    processError(response, callback) {
        // process common things here,
        // if needed before returning.

        if (typeof callback === 'function') {
            return callback(response);
        }
    },

    getToken: function () {
        return localStorage.getItem('id_token');
    },

    setToken(token) {
        localStorage.setItem('id_token', token);
    },

    removeToken() {
        localStorage.removeItem('id_token');
    },

    authHeader() {
        return {
            Accept: 'application/json',
            Authorization: 'Bearer ' + this.getToken()
        }
    },
}



// WEBPACK FOOTER //
// ./src/libs/resources.js